<template>
  <div class="">
    <div class="table-page-search-wrapper">
      <a-row :gutter="12" style="margin:16px 25px;">
        <!-- <a-col class="a-large-form" >
          <a-form-item label="" style="margin-bottom:0px">
            <a-input placeholder="请输入课程名称" style="width:100%" v-model="queryParam.name"></a-input>
          </a-form-item>
        </a-col>
        <a-button @click="searchQuery" type="primary" style="margin-left:5px;vertical-align: middle;">筛选</a-button> -->

        <a-col style="float:right;">
          <span style="margin-bottom:0px" class="table-page-search-submitButtons">
            <!-- <a-button @click="courseHoursCreate()" type="primary" icon="plus" style="margin-left:8px;">新增课时</a-button> -->
            <a-button @click="testPaperCreate()" type="primary" icon="plus" style="margin-left:8px;">添加考试科目</a-button>
          </span>
        </a-col>
      </a-row>
    </div>
    <div>
      <a-table
        ref="table"
        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination">
        
        <!--  -->
        <span slot="action" slot-scope="text, record,index">
          <a @click="editExamItem(record.id)" >编辑</a>
          <a-divider type="vertical" />
            <a-popconfirm title="删除科目吗?" @confirm="() => handleDelete(record.id)">
              <a >删除</a>
            </a-popconfirm>
          <!-- <span v-if="record.type==1">
            <a @click="courseChapterEdite(record.chapterId)" v-if="record.children" >编辑章节</a>
            <a-divider type="vertical" />
            <a-popconfirm title="确定下架吗?" @confirm="() => courseChapterDel(record.chapterId)">
              <a>删除章节</a>
            </a-popconfirm>
            <a-divider type="vertical" />
            <a @click="courseHoursCreate(record)" v-if="record.children">新增课时</a>
            <a-divider type="vertical" />
            <a-popconfirm title="确定下架吗?" v-if="record.status==1" @confirm="() => chapterShelf(record.chapterId)">
              <a>下架</a>
            </a-popconfirm>

            <a-popconfirm title="确定上架吗?" v-else @confirm="() => chapterShelf(record.chapterId)">
              <a>上架</a>
            </a-popconfirm>

          </span>

          <span v-if="record.type==2">
            <a @click="courseHoursEdite(record)" >编辑课时</a>
            <a-divider type="vertical" />
            <a-popconfirm title="删除课时吗?" @confirm="() => courseHoursDel(record)">
              <a >删除课时</a>
            </a-popconfirm>
            <a-divider type="vertical" />

            <a-popconfirm title="确定下架吗?" v-if="record.status==1" @confirm="() => courseHourShelf(record.id)">
              <a>下架</a>
            </a-popconfirm>

            <a-popconfirm title="确定上架吗?" v-else @confirm="() => courseHourShelf(record.id)">
              <a>上架</a>
            </a-popconfirm>
          </span> -->

        </span>

      </a-table>
    </div>
  </div>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'

  // import { deleteChapter, deleteCourseHour, courseHourShelf, chapterShelf } from '@/api/api'

  export default {
    name: 'TestPaperManage',
    components: {
      
    },
    mixins: [JeecgListMixin],
    data() {
      return {
        firstIsNotLoad: true,
        queryParam: {
          id: ''
        },
        loading: false,
        visible: false,
        description: '课时管理',
        url: {
          list: '/exercise/elinkxExam/examItemList',
          delete: '/exercise/elinkxExam/deleteExamItem',
          // deleteBatch: '/course/elinkxCourse/deleteBatch',
          // exportXlsUrl: 'course/elinkxCourse/exportXls',
          // importExcelUrl: 'course/elinkxCourse/importExcel'
        },
        ipagination: false,
        columns: [
          {
            title: '科目编号',
            dataIndex: '',
            key:'rowIndex',
            width:80,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title: '考试科目',
            align: 'center',
            dataIndex: 'subjectName',
            width: 100
            // customRender: (text, row, index) => {
            //   if (row.type == 1) {
            //     return (
            //       <span>
            //         <span style='color:#333;font-size:14px;'>{row.name}</span>
            //         <span style='color:#999;font-size:12px;'>（含{row.children.length}节课时）</span>
            //       </span>
            //     )
            //   } if (row.type == 2) {
            //     return (
            //       <span>
            //         <span style='color:#333;font-size:14px;'>{row.name}</span>
            //       </span>
            //     )
            //   } 
            // }
            // scopedSlots: { customRender: 'courseName' }
          },
          {
            title: '考试时间',
            align: 'center',
            width: 230,
            dataIndex: 'startTime',
            customRender:function (text,record) {
              return (<span>{record.startTime} ～
              {record.endTime}</span>)
            }
          },
          {
            title: '总分',
            align: 'center',
            dataIndex: 'score',
            width: 100,
            // customRender: (text, row, index) => {
            //   // if(row.children){
            //   //   return "";
            //   // }else{
            //     if (row.type != 3) {
            //       return (<span style='color:#333;font-size:12px;'>{row.status == 1 ? '已上架' : <span style="color:#71818E">已下架</span>}</span>)
            //     } else {
            //       return '-'
            //     }
            //   // }
            // }
          },
          {
            title:'更新人',
            align:"center",
            dataIndex: 'createBy_dictText',
            width:80,
            customRender:function (text,record) {
              if (record.updateBy_dictText){
                return record.updateBy_dictText;
              }
              return record.createBy_dictText;
              
            }
          },
          {
            title:'更新时间',
            align:"center",
            width:120,
            dataIndex: 'updateTime',
            customRender:function (text,record) {
              if(text){
                return text;
              }
              return record.createTime;
            }
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            scopedSlots: { customRender: 'action' },
            width: 300
          }
        ],
        dataSource: [

        ]
      }
    },

    created() {
      this.queryParam.id = this.$route.query.examId
      this.loadData()

    },

    methods: {

      // 新增科目
      testPaperCreate() {
        this.$router.push({ path: '/exerciseManage/createTestItem?examId=' + this.queryParam.id })
      },

      // 删除科目
      deleteExamItem(chapterIdPram) {
        deleteChapter({ id: chapterIdPram }).then((res) => {
          if (res.code == 0) {
            this.$message.success(res.message)
            this.loadData()
          } else {
            this.$message.warning(res.message)
          }
        }).finally(() => {

        })
      },

      // 编辑科目
      editExamItem(chapterIdPram) {
        this.$router.push({ path: '/exerciseManage/createTestItem?examId=' + this.queryParam.id + '&testItemId=' + chapterIdPram })
      },
      // // 课时上下架
      // chapterShelf(chapterIdParam) {
      //   chapterShelf({ id: chapterIdParam }).then((res) => {
      //     if (res.success == true) {
      //       this.$message.success(res.message)
      //       this.loadData()
      //     } else {
      //       this.$message.warning(res.message)
      //     }
      //   }).finally(() => {

      //   })
      // },
    }
  }
</script>

<style scoped>

</style>
